<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-card
            v-if="resLoading"
            class="d-flex align-center justify-center"
            flat
            min-height="50vh"
          >
            <v-progress-circular
              class="mx-auto"
              indeterminate
              size="50"
              width="5"
            />
          </v-card>
          <component
            :is="theme"
            :order.sync="data.order"
            v-else
            v-model="data"
            :components="specialInfo"
          />
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>وارد کردن اطلاعات محصول</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="data.visitName"
                        :disabled="e6 > 1"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0 contentinfo"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام محصول شما"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-data-visitName`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام محصول"
                      />
                    </div>
                  </div>

                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :order.sync="this.data.order"
                  :data="data"
                  flat
                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="markQr(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import HelpInfo from "../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize.vue";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import NewProCard from "@/view/components/Product/newProCard";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import NewDesign from "@/view/pages/product/newDesign";
import QrCodeMake from "@/view/pages/qrland/qrCodeStyle/qrCodeMake.vue";
import ImageToTextInfAi from "@/view/components/adapters/AIGeneration/imageToTextInfAi.vue";
import armsChooser from "@/view/components/Product/armsChooser.vue";
import newFactoryLabel from "../../pages/productLabel/components/newFactoryLabel.vue"
import { mapActions } from "vuex";

export default {
  name: "editLabelProduct",
  props:{
    id:{type:String, default:''},
  },

  components: {
    ImageToTextInfAi,
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    NewDesign,
    ThemeSelector2,
    ProductTheme2,
    NewProCard,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrCustomize,
    QrMaker,
    QrGenerator,
    armsChooser,
    newFactoryLabel,
  },

  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "editProduct",
      data: [],
      res: [],
      resLoading: false,
      theme: "",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdId: null,
      shortId: null,
      finish: true,
      loading: false,
      showDialog: false,
      picFrames: [
        { name: "productTheme2", src: "/media/frame/themes/t2.webp" },
        { name: "newProCard", src: "/media/frame/themes/2.svg" },
        { name: "newDesign", src: "/media/bg/product.webp" },
      ],
      customTheme: [
        { name: "newProCard", value: "" },
        { name: "productTheme2", value: "" },
        { name: "newDesign", value: "" },
      ],
      specialInfo: [
        {
          name: "factoryLabel",
          value: "",
          title: "اطلاعات محصول",
          subtitle: "",
          icon: "account-outline",
          model: "label",
        },
        {
          name: "ArmsChooser",
          value: "",
          title: "نشان اعتماد",
          subtitle: "",
          icon: "image",
          secondName: "نشان اعتماد",
          model: "arm",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
          secondName: "شبکه های اجتماعی",
        },

        {
          name: "VideoGallery",
          value: "",
          title: "افزودن ویدئو",
          subtitle: "",
          icon: "video-image",
          settings: {
            notColor: true,
          },
          // model: 'video_single'
        },
        {
          name: "imageUploader",
          value: "",
          title: "افزودن تصویر",
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
        },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: null,
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },

  watch: {
    "data.photo.gallery": {
      deep: true,
      immediate: false,
      handler(val) {
        this.$root.$emit("rerenderSwiper");
        console.log("img", val);

        if (val[0].images.length > 0) {
          this.data.label.img.text = true;
        } else {
          this.data.label.img.text = false;
        }
      },
    },
    "data.video_gallery": {
      deep: true,
      immediate: true,
      handler(val) {
        console.log("video:", val);

        const hasVideo = val?.some((item) => item.images.length > 0);
        if (this.data.label) {
          this.data.label.video.text = hasVideo;
        }
      },
    },
    "data.arm": {
      deep: true,
      handler(val) {
        if (this.data.label) {
          this.data.label.arm.text = val.length > 0;
        }
      },
    },
    // "data.FeedBack": {
    //   deep: true,
    //   immediate: true,
    //   handler(val) {
    //     if (val.items.length > 0) {
    //       this.data.label.feedback = { text: true, line: false };
    //     } else {
    //       this.data.label.feedback = { text: false, line: false };
    //     }
    //   },
    // },
    data: {
      deep: true,
      immediate: true,
      handler(val) {
        if (typeof val.label?.name === "string") {
          let newObject = {};
          let newOrder = [];
          Object.keys(val.label).map((key) => {
            newObject = {
              ...newObject,
              [key]: { text: val.label[key], line: false },
            };
          });

          this.data.label = newObject;

          newOrder = Object.keys(val.label).map((key) => {
            if (
              key !== "name" &&
              key !== "labelName" &&
              this.isValidValue(val.label[key].text, key)
            ) {
              return { name: key };
            }
          });
          this.data.order = newOrder.filter((item) => item);
          this.markQr();
        } else {
        }
      },
    },
  },

  provide: {
    provideSingleGallery: true,
  },

  mounted() {
    Bus.$on("colorPalette", (value) => {
      this.data.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.data.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.data.isGradient = value;
    });
    this.fetchData();
  },

  computed: {
    domainName() {
      return this.$route.params?.name || "";
    },
    qrId() {
      return this.$route.params?.id || "";
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID", "setQrType"]),
    ...mapActions("local", [
      "updateQrId",
      "updateQridentifier",
      "updateQrInfo",
      "updateQrDomain",
    ]),
    fetchData() {
      const fixData = (data) => {
        let fixed = { ...data.data };

        // fix singleProduct value
        if (!!fixed?.singleProduct) {
          if (!!fixed.singleProduct.title) {
            fixed.singleProduct.name = fixed.singleProduct.title;
            delete fixed.singleProduct.title;
          }

          if (fixed.singleProduct.content) {
            fixed.singleProduct.description = fixed.singleProduct.content;
            delete fixed.singleProduct.content;
          }

          if (fixed.singleProduct.details) {
            fixed.singleProduct.extra = fixed.singleProduct.details;
            delete fixed.singleProduct.details;
          }
        }
        //

        // fix video gallery
        if (!fixed.VideoGallery) {
          fixed.VideoGallery = {
            title: fixed.VideoGallerySingle?.name || "گالری ویدئو",
            description: "از ویدئوهای مجموع ما دیدن فرمایید.",
            sectionColor: {
              backGround: "",
              text: "",
            },
          };
        }

        if (!fixed.audiosGallery) {
          fixed.audiosGallery = [];
        }

        if (!fixed.video_gallery) {
          let videos = fixed.VideoGallerySingle.videos?.map((item) => ({
            name: item.title || "خوش آمدگویی",
            title: "",
            file_link:
              item.url ||
              "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
            description: item.description,
            link: item.link,
          }));

          fixed.video_gallery = [
            {
              name: "گالری",
              images: !!videos?.length
                ? [...videos]
                : [
                    {
                      name: "خوش آمدگویی",
                      title: "",
                      file_link:
                        "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
                      description: "",
                      link: "",
                      id: 15,
                    },
                  ],
            },
          ];
        }

        if (!!fixed.VideoGallerySingle) delete fixed.VideoGallerySingle;

        if (
          !fixed.label?.more ||
          (typeof fixed.label.more === "object" &&
            !Array.isArray(fixed.label.more))
        ) {
          fixed.gold = {
            ...fixed.label,
            more: [],
          };
        }

        // fix photo
        if (!!fixed?.photo && !fixed.photo.background)
          fixed.photo.background = this.$cdnUrl + "/upload/64b2bb1c4ad38.webp";
        //

        if (!fixed.companyNumberName) fixed.companyNumberName = "";

        return {
          ...data,
          data: fixed,
        };
      };

      this.loading = true;
      this.resLoading = true;


      this.$api
        .get(`qr/template/${this.id}`)
        .then(({ data }) => {
          let parsedData =
            typeof data.data.qr.data === "string"
              ? JSON.parse(data.data.qr.data)
              : data.data.qr.data;
          this.setCreatedQrID(data.data.id);

          let info = fixData(parsedData);
          this.data = info.data;
          this.updateQrInfo(info);
          this.updateQrId(data.data.id);
          this.setQrType(data.data.type);

          this.theme =
            info.theme && info.theme.length > 0 ? info.theme : "newProCard";
          this.res = data.data;
        })
        .finally(() => {
          this.loading = false;
          this.resLoading = false;
        });
    },
    isValidValue(value, key) {
      if (value == 0) return false;
      if (value == null || value === "") return false;
      if (typeof value === "string") return value.trim().length > 0;
      if (typeof value === "number") return true;
      if (Array.isArray(value)) return value.length > 0;
      if (typeof value === "object" && value.text != null)
        return value.text.toString().trim().length > 0;
      if (typeof value == "boolean") return value;
      if (typeof value === "object" && value.text == null) return false;

      return !!value;
    },
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "labelproduct",
        qrType: "dynamic",
        title: this.res.title,
        data: JSON.stringify({
          theme: this.theme,
          data: this.data,
        }),
        qr: {
          section: "#link", link: "https://qr2.in/", backcolor: "#ffffff", frontcolor: "#000000", gradient_color: "#000000", marker_out_color: "#000000", marker_in_color: "#000000", marker_top_right_outline: "#000000", marker_top_right_center: "#000000", marker_bottom_left_outline: "#000000", marker_bottom_left_center: "#000000", framecolor: "#000000", optionlogo: "none", "logo-size": 100, marker: "default", marker_in: "default", outer_frame: "none", framelabel: "SCAN ME", label_font: "AbrilFatface.svg", "label-text-size": 100, size: "248", level: "M",
        },
      };
      this.$api
        .put(`qr/template/${this.id}`, {
          qr: obj,
          type: "labelproduct",
          title: this.res.title,
        })
        .then(({ data }) => {
          this.finish = final;
          this.$toast.success("کیوآر لیبل محصول شما با موفقیت ویرایش شد.");
          this.fetchData();
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) =>
          console.log("error in get response: ", response),
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
